module.exports = __webpack_public_path__ + "img/union.6c89047c.svg";